export const TimeConfig = {
    "1m": 1,
    "2m": 2,
    "5m": 5
}



export const WebSocketUrl = "wss://feed.videalpha.com/Broadcast"